import { ClassType } from "../../../types/Class";
import { post } from "../../../utils/axios-config";
import { CLASSES } from "../../../utils/constants";

export const createClass = async (data: ClassType) => await post<ClassType, string>(CLASSES, data);